import { Id } from '@nextforce/api'

const keys = {
  all: ['company'],
  details: (companyId: Id) => [...keys.all, companyId],
  userCompanies: ['chat', 'user', 'companies'],
}

export default keys
